import { unifiedReasonStatsSchema } from "@redotech/redo-dispute-db-schema/dispute-overview-analytics";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getUnifiedReasonStats = {
  name: "getUnifiedReasonStats" as const,
  input: z.object({
    startDate: zExt.plainDate().optional(),
    endDate: zExt.plainDate().optional(),
  }),
  output: unifiedReasonStatsSchema,
};
